import { Box, Typography, Grid } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import DashboardTabs from "./DashboardTabs";

export default function ParnterViewDetail() {
  const { id } = useParams();
  const location = useLocation();
  const { userName, mobileNo, name, email, commsion_per, mmtc_commission_per } =
    location.state || {};

  return (
    <Box p={0}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          mb: 3,
          color: "#222",
        }}
      >
        Partner Details
      </Typography>

      <Box
        sx={{
          bgcolor: "#fff",
          border: "1px solid #e8e8e8",
          borderRadius: "8px",
          p: 4,
          boxShadow: "0px 2px 6px rgba(0,0,0,0.04)",
          mb: 3,
        }}
      >
        <Grid container spacing={2}>
          {/* Name */}
          <Grid item xs={12} md={4}>
            <Typography
              sx={{
                fontSize: 12,
                color: "#888",
                textTransform: "uppercase",
                mb: 0.5,
              }}
            >
              Partner Name
            </Typography>

            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 500,
                color: "#222",
              }}
            >
              {name || "-"}
            </Typography>
          </Grid>

          {/* Code */}
          <Grid item xs={12} md={4}>
            <Typography
              sx={{
                fontSize: 12,
                color: "#888",
                textTransform: "uppercase",
                mb: 0.5,
              }}
            >
              Partner Code
            </Typography>

            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 500,
              }}
            >
              {userName || "-"}
            </Typography>
          </Grid>

          {/* Email */}
          <Grid item xs={12} md={4}>
            <Typography
              sx={{
                fontSize: 12,
                color: "#888",
                textTransform: "uppercase",
                mb: 0.5,
              }}
            >
              Email
            </Typography>

            <Typography
              sx={{
                fontSize: 16,
                color: "#1976d2",
                wordBreak: "break-word",
              }}
            >
              {email || "-"}
            </Typography>
          </Grid>

          {/* Phone */}
          <Grid item xs={12} md={4}>
            <Typography
              sx={{
                fontSize: 12,
                color: "#888",
                textTransform: "uppercase",
                mb: 0.5,
              }}
            >
              Phone
            </Typography>

            <Typography
              sx={{
                fontSize: 16,
                color: "#222",
              }}
            >
              {mobileNo || "-"}
            </Typography>
          </Grid>

          {/* Augmont Commission */}
          <Grid item xs={12} md={4}>
            <Typography
              sx={{
                fontSize: 12,
                color: "#888",
                textTransform: "uppercase",
                mb: 0.5,
              }}
            >
              Augmont Commission
            </Typography>

            <Box
              sx={{
                display: "inline-block",
                px: 1.2,
                py: 0.3,
                bgcolor: "#E8F5E9",
                color: "#2E7D32",
                borderRadius: 1,
                fontWeight: 500,
                fontSize: 14,
              }}
            >
              {commsion_per ?? "-"}%
            </Box>
          </Grid>

          {/* MMTC Commission */}
          <Grid item xs={12} md={4}>
            <Typography
              sx={{
                fontSize: 12,
                color: "#888",
                textTransform: "uppercase",
                mb: 0.5,
              }}
            >
              MMTC Commission
            </Typography>

            <Box
              sx={{
                display: "inline-block",
                px: 1.2,
                py: 0.3,
                bgcolor: "#E8F5E9",
                color: "#2E7D32",
                borderRadius: 1,
                fontWeight: 500,
                fontSize: 14,
              }}
            >
              {mmtc_commission_per ?? "-"}%
            </Box>
          </Grid>
        </Grid>
      </Box>

      <DashboardTabs id={id} />
    </Box>
  );
}
